/* eslint-disable @typescript-eslint/camelcase */
import {TYPES} from "../libs/config";

export interface PollAnswerMsg {t: number; b: any }

export function makePollAnswerMsg(body: any, question: any): PollAnswerMsg {
    const pollAnswerMsg: PollAnswerMsg = {
        t: TYPES.POLL_ANSWER,
        b: body
    }

    if (typeof question.instance_id !== 'undefined') {
        pollAnswerMsg.b.instance_id = question.instance_id;
    }
    if (typeof question.question_id !== 'undefined') {
        pollAnswerMsg.b.question_id = question.question_id;
    }
    if (typeof question.chat_id !== 'undefined') {
        pollAnswerMsg.b.chat_id = question.chat_id;
    }

    return pollAnswerMsg;
}